/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiAdminsQueryResponse, GetApiAdminsQueryParams, GetApiAdmins400, GetApiAdmins401, GetApiAdmins403, GetApiAdmins500 } from "../../types/GetApiAdmins.ts";
import { getApiAdminsQueryResponseSchema } from "../../zod/SuperAdminSchemas/getApiAdminsSchema.ts";

function getGetApiAdminsUrl() {
  const res = { method: 'GET', url: `/api/admins` as const }  
  return res
}

/**
 * @summary Получение списка администраторов (Доступно только для суперадмина)
 * {@link /api/admins}
 */
export async function getApiAdmins({ params }: { params?: GetApiAdminsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiAdminsQueryResponse, ResponseErrorConfig<GetApiAdmins400 | GetApiAdmins401 | GetApiAdmins403 | GetApiAdmins500>, unknown>({ method : "GET", url : getGetApiAdminsUrl().url.toString(), params, ... requestConfig })  
  return getApiAdminsQueryResponseSchema.parse(res.data)
}